<i18n src="@/i18n/enums/shipment_status.json"></i18n>
<template>
	<p>
		<span :class="badgeClass" class="px-2 py-1 inline-flex items-center rounded-full  leading-4 text-xs whitespace-nowrap">
			<svg class="h-1.5 w-1.5 mr-1.5" viewBox="0 0 6 6" aria-hidden="true">
				<circle cx="3" cy="3" r="3" />
			</svg>
			{{ badgeLabel }}
		</span>
	</p>
</template>

<script>
import {hash as ShipmentStatusOptions} from "@/enums/shipment_status.js"

export default {
	name: "ShipmentStatusBadge",
	props: ["shipment"],
	computed: {
		shipmentStatus() {
			return translateEnum(this, ShipmentStatusOptions, 'shipmentStatus.')
		},
		badgeClass() {
			return this.shipmentStatus[this.shipment.shipment_status].class
		},
		badgeLabel() {
			return this.shipmentStatus[this.shipment.shipment_status].label
		}
	}
}
</script>